module.exports = __webpack_public_path__ + "img/4.1.89f06506.png";